<template>
  <v-card color="#f1f1f1">
    <v-toolbar color="#2039CC" dark>
      <v-card-title>{{ $capitalize($tc("model.marketplace_ew_budget")) }}</v-card-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('cancel')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text style="height: 100vh" id="scroll-target">
      <v-container
        class="mt-10"
        v-scroll:#scroll-target="handleScroll"
        ref="scrollTarget"
      >
        <v-row>
          <v-col cols="4" md="4" lg="3">
            <v-list-item class="mb-7">
              <v-list-item-content>
                <v-list-item-title class="title">
                  {{ $capitalize($tc("model.marketplace_search_ad")) }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-2">
                  {{ total_products }} resultados
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-text-field
              v-model="filter"
              :label="$capitalize($tc('model.marketplace_search_ad'))"
              prepend-inner-icon="mdi-magnify"
              solo
              dense
              @keyup.enter="filterProduct()"
              :loading="loading_products"
              clearable
              @click:clear="clearFilter()"
            ></v-text-field>
            <v-card class="mb-5">
              <v-list dense>
                <v-subheader
                  ><v-icon small class="mr-1">mdi-filter</v-icon>
                  {{ $capitalize($tc("model.marketplace_filters")) }}</v-subheader
                >
                <v-list-item
                  v-for="feature in features_filter"
                  :key="feature.id"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ feature.name }}</v-list-item-title>
                    <div>
                      <v-chip
                        v-for="value in feature.values"
                        :key="feature.id + value"
                        class="mr-1 my-1"
                        close
                        @click:close="addFeatureFilter(feature, value)"
                        small
                        :disabled="loading_products"
                        >{{ value }}</v-chip
                      >
                    </div>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item key="brands">
                  <v-list-item-content>
                    <v-list-item-title>{{ $capitalize($tc("model.marketplace_brand")) }}</v-list-item-title>
                    <div>
                      <v-select
                        class="mr-1 my-1"
                        label
                        small
                        :items="brands"
                        item-text="name"
                        item-value="id"
                        dense
                        hide-details
                        v-model="selected_brand"
                        @change="filterProduct()"
                        clearable
                        :disabled="loading_products"
                      >
                      </v-select>
                    </div>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item key="price">
                  <v-list-item-content>
                    <v-list-item-title>{{ $capitalize($tc("model.marketplace_price")) }}</v-list-item-title>
                    <v-row no-gutters>
                      <v-col class="pr-2">
                        <vuetify-money
                          v-model="min_price_filter"
                          name="price"
                          type="text"
                          :options="money"
                          :label="$capitalize($tc('model.marketplace_minimum'))"
                          single-line
                          :disabled="loading_products"
                          @keyup.enter="filterProduct()"
                          @change="filterProduct()"
                        />
                      </v-col>
                      <v-col class="pl-2">
                        <vuetify-money
                          v-model="max_price_filter"
                          name="price"
                          type="text"
                          :options="money"
                          :label="$capitalize($tc('model.marketplace_maximum'))"
                          single-line
                          :disabled="loading_products"
                          @keyup.enter="filterProduct()"
                          @change="filterProduct()"
                        />
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
            <v-card flat>
              <div
                v-if="loading_features"
                class="d-flex align-center justify-center"
                style="background-color: #f1f1f1; min-height: 200px"
              >
                <span class="grey--text">{{ $capitalize($tc("model.marketplace_loading")) }}</span>
              </div>
              <v-list v-else color="#f1f1f1" dense expand>
                <v-subheader
                  ><v-icon left>mdi-format-list-bulleted</v-icon>
                  {{ $capitalize($tc("model.marketplace_attributes_subtitle")) }}</v-subheader
                >
                <v-list-group
                  v-for="feature in limited_features"
                  :key="feature.id"
                  append-icon=""
                  :value="true"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="feature.name"
                        class="subtitle-2"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item
                    v-for="value in feature.values"
                    :key="feature.id + value.value"
                    class="p-0 m-0"
                  >
                    <v-simple-checkbox
                      @input="addFeatureFilter(feature, value.value)"
                      :value="isValueActive(feature, value.value)"
                      class="mr-2"
                      :disabled="loading_products"
                    ></v-simple-checkbox>
                    <v-list-item-content class="p-0 m-0">
                      <v-list-item-title class="font-weight-regular"
                        >{{ value.value }}
                        <span class="grey--text"
                          >({{ value.products }})</span
                        ></v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="my-4"></v-divider>
                </v-list-group>
              </v-list>
            </v-card>
          </v-col>
          <v-col cols="8" md="8" lg="6">
            <v-sheet class="mb-0 text-right" color="#f1f1f1">
              <v-row>
                <v-col cols="10"> </v-col>
                <v-col>
                  <!-- <v-btn text small
                    >Nome <v-icon small>mdi-arrow-down</v-icon></v-btn
                  > -->
                </v-col>
              </v-row>
            </v-sheet>
            <div v-if="loading_products && !products.length">
              <v-card
                class="mb-2"
                outlined
                v-for="x in [1, 2, 3, 4, 5]"
                :key="x"
              >
                <v-row>
                  <v-col cols="4" class="px-10 py-5">
                    <v-skeleton-loader
                      class="mx-auto"
                      tile
                      type="image"
                    ></v-skeleton-loader>
                  </v-col>
                  <v-col>
                    <v-skeleton-loader
                      class="mx-auto"
                      tile
                      type="article"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
              </v-card>
            </div>
            <EmptyState
              :message="$capitalize($tc('model.marketplace_no_ads_found'))"
              height="500"
              :when="!products.length && !loading_products"
              outlined
            />
            <v-card
              v-for="product in products"
              :key="product.id"
              height="270"
              class="mb-2"
              outlined
            >
              <v-row no-gutters style="height: 100%">
                <v-col
                  cols="3"
                  class="d-flex align-center justify-center"
                  style="height: 100%"
                >
                  <v-img
                    v-if="product.image_url"
                    :aspect-ratio="16 / 9"
                    :src="product.image_url"
                    height="160"
                    contain
                    class="m-auto"
                  >
                    <template v-slot:placeholder>
                      <v-overlay absolute height="270">
                        <v-icon>mdi-image-off</v-icon>
                      </v-overlay>
                    </template>
                  </v-img>
                  <v-img
                    v-else
                    :src="product.image_url"
                    height="270"
                    contain
                    class="m-auto"
                  >
                    <template v-slot:placeholder>
                      <v-overlay absolute height="270">
                        <v-icon>mdi-image-off</v-icon>
                      </v-overlay>
                    </template>
                  </v-img>
                </v-col>
                <v-col>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                  <v-card-title
                    class="font-weight-light"
                    style="margin-top: -15px"
                  >
                    {{ product.name }}
                  </v-card-title>
                  <v-card-subtitle class="font-weight-light">
                    {{ $capitalize($tc("model.marketplace_sold_by")) }} {{ product.store }}
                    <br />
                    <v-chip
                      v-if="product.availability == 'InStock'"
                      small
                      color="green"
                      label
                      dark
                      outlined
                      class="mt-1"
                      >{{ $capitalize($tc("model.marketplace_in_stock")) }}</v-chip
                    >
                    <v-chip class="mt-1" v-else small outlined label
                      >{{ $capitalize($tc("model.marketplace_unavailable")) }}</v-chip
                    >
                    <v-chip
                      small
                      label
                      outlined
                      class="mt-1 ml-1"
                      :title="$capitalize($tc('model.marketplace_bar_code'))"
                    >
                      <v-icon small left class="grey--text">mdi-barcode</v-icon>
                      {{ product.ean }}</v-chip
                    >
                    <br />
                  </v-card-subtitle>

                  <v-card-text>
                    <span class="title">{{ parseMoney(product.price) }}</span>
                    <br />
                    <v-chip
                      @click="handleSelectBudget(product)"
                      class="mt-5"
                      small
                    >
                      <v-icon small class="mr-1">mdi-plus</v-icon> {{ $capitalize($tc("model.marketplace_add")) }}
                    </v-chip>
                    <v-chip
                      class="mt-5 ml-1"
                      small
                      outlined
                      @click="openProductDialog(product)"
                    >
                      <v-icon small class="mr-1">mdi-magnify</v-icon> {{ $capitalize($tc("model.marketplace_details")) }}
                    </v-chip>
                  </v-card-text>
                </v-col>
                <v-col cols="1"></v-col>
              </v-row>
              <v-card-actions> </v-card-actions>
            </v-card>
            <div class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
                v-if="loading_products"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- <v-col cols="3" class="d-none d-xl-block" v-show="false">
            <v-card outlined>
              <v-card-title>Máquina de Lavar Roupa LG FH2J3TDN0</v-card-title>

              <v-list>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-barcode</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>12312312123</v-list-item-title>
                    <v-list-item-subtitle>EAN</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-diving-scuba-flag</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>LG</v-list-item-title>
                    <v-list-item-subtitle>Marca</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-package-variant</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>FH2J3TDN0</v-list-item-title>
                    <v-list-item-subtitle>Modelo</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col> -->
        </v-row>
      </v-container>
      <v-dialog v-model="product_detail_catalog" max-width="800px">
        <MarketplaceProductDetail
          :id="opened_product_id"
          @close="closeMarketplace"
        />
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import { index as indexFeatures } from "@/services/products/features";
import { index as indexProducts } from "@/services/products/products";
import { index as indexBrands } from "@/services/products/brands";
import money_tool from "@/tools/money";

import EmptyState from "@/components/EmptyState";
import MarketplaceProductDetail from "@/components/Lead/MarketplaceProductDetail";

export default {
  name: "marketplace",
  components: { EmptyState, MarketplaceProductDetail },
  props: ["product"],
  data: () => ({
    features: [],
    products: [],
    total_products: 0,
    show_all_features: false,
    page: 1,
    loading_products: false,
    loading_features: false,
    filter: "",
    features_filter: [],
    min_price_filter: null,
    max_price_filter: null,
    brands: [],
    selected_brand: null,
    money: {
      prefix: "€ ",
      suffix: "",
      precision: 2,
      length: 11,
      locale: "pt-PT"
    },
    offsetTop: 0,
    product_detail_catalog: false,
    opened_product_id: null
  }),
  methods: {
    closeMarketplace() {
      this.product_detail_catalog = false;
      this.opened_product_id = null;
    },
    openProductDialog(product) {
      this.product_detail_catalog = true;
      this.opened_product_id = product?.id;
    },
    handleSelectBudget(budget) {
      this.$emit("budget_selected", budget);
    },
    isValueActive(feature, feature_value) {
      return !!this.features_filter.find(feature_filter => {
        return (
          feature_filter.id == feature.id &&
          feature_filter.values.find(
            feature_filter_value => feature_filter_value == feature_value
          )
        );
      });
    },
    addFeatureFilter(feature, value) {
      const feature_filter = this.features_filter.find(f => f.id == feature.id);

      const create_new_filter = (feature, value) => {
        this.features_filter.push({
          ...feature,
          values: [value]
        });
      };

      const toggle_value = (feature, value) => {
        if (feature.values.find(feature_value => feature_value == value)) {
          return feature.values.filter(
            feature_value => feature_value !== value
          );
        } else {
          return [...feature.values, value];
        }
      };

      if (!feature_filter) {
        create_new_filter(feature, value);
      } else {
        this.features_filter = this.features_filter.map(filter => {
          if (filter.id == feature.id) {
            const new_filter = {
              ...filter,
              values: toggle_value(filter, value)
            };

            return new_filter;
          } else {
            return filter;
          }
        });

        // Remove atributos sem valores.
        this.features_filter = this.features_filter.filter(
          filter => filter.values.length
        );
      }

      this.filterProduct();
    },
    parseMoney(text) {
      return money_tool.euro(text);
    },
    async getFeatures() {
      this.loading_features = true;

      try {
        this.features = await indexFeatures({
          category_id: this.local_category_id
        });
      } catch (error) {
      } finally {
        this.loading_features = false;
      }
    },
    async getProducts() {
      this.loading_products = true;
      try {
        const response = await indexProducts({
          local_category_id: this.local_category_id,
          filter: this.filter,
          page: this.page,
          features: this.features_filter,
          brand_id: this.selected_brand,
          min_price: this.min_price_filter,
          max_price: this.max_price_filter
        });
        this.products = this.products.concat(response.data);
        this.total_products = response.total;
      } catch (error) {
      } finally {
        this.loading_products = false;
      }
    },
    async getBrands() {
      const response = await indexBrands({
        list: true,
        local_category_id: this.local_category_id
      });

      this.brands = response;
    },
    filterProduct() {
      this.products = [];
      this.page = 1;
      this.getProducts();
    },
    clearFilter() {
      this.filter = "";
      this.filterProduct();
    },
    nextPage() {
      if (this.loading_products) return;
      if (this.products.length >= this.total_products) return;

      this.page = this.page + 1;
      this.getProducts();
    },
    handleScroll(event) {
      const max_heigth = this.$refs.scrollTarget.offsetHeight;

      this.offsetTop = event.target.scrollTop;
      if (this.offsetTop + 2000 > max_heigth) {
        this.nextPage();
      }
    }
  },
  computed: {
    limited_features: function() {
      if (this.show_all_features) {
        return this.features;
      } else {
        return this.features.slice(0, 5);
      }
    },
    local_category_id: function() {
      return this.product.local_category_id;
    }
  },
  created() {
    this.filter = this.product.model;
    this.selected_brand = this.product.brand_id;

    this.getFeatures();
    this.getProducts();
    this.getBrands();
    // this.$refs.marketplace_window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    // this.$refs.marketplace_window.removeEventListener(
    //   "scroll",
    //   this.handleScroll
    // );
  },
  watch: {
    local_category_id: function() {
      this.filterProduct();
      this.getFeatures();
      this.getBrands();
    }
  }
};
</script>
